<template>
    <div id="viewProject">
        <div class="title black">PROJECT</div>
        <project-item
            v-for="(ele, index) in tit"
            :key="index"
            :title="tit[index]"
            :img="img[index]"
            :date="date[index]"
            :type="type[index]"
            :git="git[index]"
            :what="what[index]"
            :stack="stack[index]"
            :site="site[index]"
        ></project-item>
    </div>
</template>
<script>
import ProjectItem from "@/components/project/ProjectItem";
export default {
    name: "ViewProject",
    components: {
        ProjectItem,
    },
    data() {
        return {
            len: 5,
            tit: ["내가 사는 그 집", "배스킨 라빈스31", "HARRY POTTER", "화순 군청", "광복"],
            date: [
                "2021.05 ~ 2021.05",
                "2021.03 ~ 2021.03",
                "2019.10 ~ 2019.10",
                "2019.09 ~ 2019.10",
                "2019.09 ~ 2019.09",
            ],
            img: [
                "happyhouse.png",
                "baskinrabins.png",
                "ssgssagP.png",
                "Waang.png",
                "gwangbok.png",
            ],
            type: ["팀 프로젝트", "팀 프로젝트", "개인 프로젝트", "개인 프로젝트", "개인 프로젝트"],
            git: [
                "https://github.com/sowon901/HoneyPot",
                "https://github.com/sowon901/BaskinRobbins_Web_Project",
                "https://github.com/sowon901/HarryPotter_Web_Project",
                "https://github.com/sowon901/HwaSun_Web_Project",
                "https://github.com/sowon901/GwangBok_Web_Project",
            ],
            what: [
                "레이아웃 디자인\n프론트엔드 로그인, 거래정보, 찜목록 기능 개발",
                "레이아웃 디자인\n프론트엔드 전체 기능 개발\nLocalStorage를 이용한 로그인 기능 개발",
                "레이아웃 디자인\n프론트엔드 전체 기능 개발",
                "레이아웃 디자인\n프론트엔드 전체 기능 개발",
                "레이아웃 디자인\n프론트엔드 전체 기능 개발",
            ],
            stack: [
                "Vue, SpringBoot, MySQL",
                "HTML, CSS, JavaScript, jQuery, Bootstrap",
                "HTML, CSS, JavaScript, jQuery",
                "HTML, CSS, JavaScript, jQuery",
                "HTML, CSS, JavaScript, jQuery",
            ],
            site: [
                "https://github.com/sowon901/HoneyPot",
                "https://sowon901.github.io/BaskinRobbins_Web_Project/",
                "https://sowon901.github.io/HarryPotter_Web_Project/",
                "https://sowon901.github.io/HwaSun_Web_Project/",
                "https://sowon901.github.io/GwangBok_Web_Project/",
            ],
        };
    },
};
</script>
<style>
#viewProject > div:first-child {
    color: #12104e;
    margin-bottom: 100px;
}
.projectItem {
    margin-bottom: 250px;
}
</style>
